import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoaderService } from '../shared/loader/services/loader.service';
import { EnfermeraRequest } from '../models/enfermera-request.interface';
import { HttpRespuesta } from '../models/http-respuesta.interface';
import { Enfermera } from '../models/enfermera.interface';
import { TotalesEnfermera } from '../models/totales-generales.interface';
import { EstadoCuenta } from '../models/estado-cuenta.interface';
import { CanjeEnfermera, RedimirEnfermera, SolicitudCanjeEnfermera } from '../models/redimir.interface';

const httpOptions = {
  headers: new HttpHeaders({

    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',

  })
};

@Injectable({
  providedIn: 'root'
})
export class EnfermeraService {


  constructor(private httpclient: HttpClient, private loaderService: LoaderService) { }

  nuevaEnfermera(enfermera: EnfermeraRequest): Observable<HttpRespuesta<Enfermera>> {
    this.loaderService.activar()
    return this.httpclient.post<HttpRespuesta<Enfermera>>(environment.api.enfermeras, enfermera, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  totales(id: number): Observable<HttpRespuesta<TotalesEnfermera>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<TotalesEnfermera>>(environment.api.enfermeraTotales + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }
  getEnfermera(id: number): Observable<HttpRespuesta<Enfermera>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Enfermera>>(environment.api.enfermeras + "/" + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  getEnfermeraPreSolicitud(id: number): Observable<HttpRespuesta<Enfermera>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Enfermera>>(environment.api.presolicitudCanjeEnfermera + "/" + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  getEstadoCuenta(id: number): Observable<EstadoCuenta[]> {
    this.loaderService.activar();
    return this.httpclient.get<EstadoCuenta[]>(environment.api.estadoCuentaEnfermera + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setSolicitudCanje(canje: SolicitudCanjeEnfermera): Observable<HttpRespuesta<RedimirEnfermera>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirEnfermera>>(environment.api.solicitudCanjeEnfermera, canje, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  getRedimirEnfermeraDetalle(id: string): Observable<HttpRespuesta<RedimirEnfermera>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<RedimirEnfermera>>(environment.api.redimirEnfermeraAtender + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
}
